import React from "react";

import "./Footer.css";

function Footer() {
  return (
    <div className="footer p-5">
      <p className="m-0 text-center">Copyright &copy; 2021 BSS</p>
    </div>
  );
}

export default Footer;
